/**
 * API endpoint constants - single source for backend paths
 */

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    VALIDATE_EMAIL: '/auth/validate-email',
    LOGOUT: '/auth/logout',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    ME: '/auth/me',
    PERMISSIONS: '/auth/permissions',
    CSRF_TOKEN: '/auth/csrf-token',
  },
  REFERRALS: {
    BASE: '/referrals',
    /** GET /referrals/admin/stats/{referralCode} - totalReferralCount, totalRewardPointsSum */
    ADMIN_STATS: (referralCode: string) => `/referrals/admin/stats/${encodeURIComponent(referralCode)}`,
  },
  REFERRAL_CODES: {
    BASE: '/referral-codes',
    BY_UUID: (uuid: string) => `/referral-codes/${uuid}`,
  },
  EVENTS: {
    BASE: '/events',
    DROPDOWN: '/events/dropdown',
    BY_UUID: (uuid: string) => `/events/${uuid}`,
    STATUS: (uuid: string) => `/events/${uuid}/status`,
  },

  TENANTS: {
    BASE: '/tenants',
    DROPDOWN: '/tenants/dropdown',
    BY_UUID: (uuid: string) => `/tenants/${uuid}`,
    BY_StartMigrationUUID: (uuid: string) => `/tenants/start-migration/${uuid}`,
    APPLY_PENDING_MIGRATIONS: (uuid: string) =>
      `/tenants/apply-pending-migrations/${uuid}`,
    STATUS: (uuid: string) => `/tenants/toggle-status/${uuid}`,
    CUSTOM_PARSER_CATALOG_BYPASS: (uuid: string) =>
      `/tenants/toggle-custom-parser-catalog-bypass/${uuid}`,
  },

  CREDITLIMIT: {
    BASE: '/api-credit',
    ADD: '/api-credit/add',
    CREDITTRANSATION: '/api-credit/transactions',
    CREDITUSAGELOGS: '/api-credit/usage-logs',
    BY_UUID: (uuid: string) => `/api-credit/${uuid}`,
  },

  DOCUMENT_ENDPOINTS: {
    BASE: '/document-endpoints',
    CATEGORIES: '/document-endpoints/categories',
    CHECK_UNIQUENESS: '/document-endpoints/check-uniqueness',
    BY_UUID: (uuid: string) => `/document-endpoints/${uuid}`,
    DELETION_ELIGIBILITY: (uuid: string) =>
      `/document-endpoints/${uuid}/deletion-eligibility`,
    BY_TENANT: (uuid: string) => `/tenants/${uuid}/document-endpoints`,
    STATUS: (uuid: string) => `/document-endpoints/${uuid}/status`,
  },

  PROGRAMS: {
    BASE: '/programs',
    BY_UUID: (uuid: string) => `/programs/${uuid}`,
  },
  SETTINGS: {
    BASE: '/settings',
    BY_ID: (id: string) => `/settings/${id}`,
  },
  REWARDS: {
    BASE: '/rewards',
  },
  POINT_WALLETS: {
    BALANCES: '/point-wallets/balances',
    TRANSACTIONS: '/point-wallets/transactions',
  },
  IMAGES: {
    URL: (uuid: string) => `/images/${uuid}/url`,
  },
} as const;
